import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[ClickOutsideElement]',
})
export class ClickOutsideElementDirective {
  constructor(private elementRef: ElementRef) {}

  @Output() ClickOutsideElement: EventEmitter<any> = new EventEmitter();

  @HostListener('click', ['$event.target']) onClick(targetElement: any): void {
    try {
      const clickedInside = this.elementRef.nativeElement.contains(targetElement);
      if (!clickedInside) {
        this.ClickOutsideElement.emit({ bol: true, elementtarget: targetElement });
      }
      // else {
      //   this.ClickOutsideElement.emit({ bol: false, elementtarget: targetElement });
      // }
    } catch (error) {
      console.log('Error => ', error?.message);
    }
  }
}
